export default __webpack_public_path__ + "static/media/nbcharro.7d31b493.png";